import { IconChevronRight } from '@holbonkit/icons'
import { Box, Text } from '@holbonkit/ui'
import { clsx } from 'clsx'

import type { GetSelfEmployedFinanceResponse } from '@/shared/api'
import { BankIcon } from '@/shared/ui'
import { IconSbp } from '@/shared/ui/icon/icon-sbp'

import styles from './method-slot.module.scss'

type TPayoutMethod = NonNullable<GetSelfEmployedFinanceResponse['payout_method']>

type TMethodSlotProps = {
    isDisabled: boolean
    isOpen: boolean
    onClick: () => void
    payoutMethod: TPayoutMethod | undefined
}

export const MethodSlot = ({ isDisabled, isOpen, onClick, payoutMethod }: TMethodSlotProps) => {
    const hasAccount = Boolean(payoutMethod?.bank_id)

    return (
        <Box
            aria-hidden={!isOpen}
            data-test-id='withdrawal-smz-method-slot'
            className={clsx(
                styles['method-slot'],
                isOpen && styles['method-slot--open'],
                isDisabled && styles['method-slot--disabled'],
            )}
            onClick={onClick}
        >
            <Box className={styles['method-slot__inner']}>
                <Box className={styles['method-slot__method']}>
                    <div className={styles['method-slot__icon']}>
                        {hasAccount ?
                            <BankIcon
                                name={payoutMethod?.bank_name ?? ''}
                                url={payoutMethod?.bank_icon_url ?? null}
                            />
                        :   <IconSbp size={24} />}
                    </div>
                    <Box className={styles['method-slot__info']}>
                        <Text
                            className={styles['method-slot__subtitle']}
                            variant='body-s-14-regular'
                        >
                            Способ вывода
                        </Text>
                        <Text variant='body-m-16-medium'>
                            {hasAccount ? `СБП • ${payoutMethod?.bank_name}` : 'Добавить счёт СБП'}
                        </Text>
                    </Box>
                    <IconChevronRight color='var(--text-and-icon-secondary)' size={24} />
                </Box>
            </Box>
        </Box>
    )
}
